import { render, staticRenderFns } from "./BEmailEditor.vue?vue&type=template&id=5e155580"
import script from "./BEmailEditor.vue?vue&type=script&lang=js"
export * from "./BEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./BEmailEditor.vue?vue&type=style&index=0&id=5e155580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports